import { type FC } from "react";

import { css } from "@emotion/css";
import { Spacing } from "@snapchat/snap-design-system";
import { ChevronDownIcon } from "@snapchat/snap-design-system-icons";
import { type DropdownIndicatorProps, components } from "react-select";

import { type Option } from "../models";

const dropdownArrow = css`
    cursor: pointer;
    margin-right: ${Spacing.XS}px;
`;

export const SelectDropdownIndicator: FC<DropdownIndicatorProps<Option>> = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <ChevronDownIcon data-testid="dropdown-indicator" size={12} className={dropdownArrow} />
        </components.DropdownIndicator>
    );
};
